export default {
  setItem(key, value) {
    if (typeof sessionStorage !== 'undefined') {
      sessionStorage.setItem(key, value);
    }
  },
  getItem(key) {
    if (typeof sessionStorage !== 'undefined') {
      return sessionStorage.getItem(key);
    }

    return null;
  },
  removeItem(key) {
    if (typeof sessionStorage !== 'undefined') {
      sessionStorage.removeItem(key);
    }
  },
  clear() {
    if (typeof sessionStorage !== 'undefined') {
      sessionStorage.clear();
    }
  },
};



// WEBPACK FOOTER //
// ./src/services/storage.js